// extracted by mini-css-extract-plugin
export default {"table":"table--ASgO4","justLabel":"justLabel--gmzLm","customCell":"customCell--CAxuZ","amount":"amount--a2Pw6"};